import React from 'react';
import cn from '@/utils/cn';
import { dataFrameClass } from '../shared/SPADataTable';

// "active" is the only state where limits are actually enforced. When it is anything else the
// gateway is serving traffic unenforced, and the plugin's own log line is the only thing that says
// why — an ABI mismatch and a bad config read identically from the status alone.
const PluginHealth = ({ logs, status }: { logs?: string[]; status: string | null }) => {
  if (status === 'active') return null;

  const lines = logs ?? [];

  return (
    <div className="tw-mb-7" role="alert">
      <p className="tw-m-0 tw-text-sm tw-text-spa-error">
        {`Plugin ${status ?? 'unknown'} — limits are not being enforced.`}
      </p>
      {lines.length > 0 && (
        <pre className={cn(dataFrameClass, 'tw-mb-0 tw-mt-2 tw-p-4 tw-text-xs tw-text-spa-primary')}>
          {lines.join('\n')}
        </pre>
      )}
    </div>
  );
};

export default PluginHealth;
